import React from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "../../../components/ui/alert";

// EMAILS-IMPL-007: renders the friendly message describeMutationError()
// (lib/emailMarketingApi.js) already produced -- this component never
// re-inspects the raw error itself, so a raw stack trace / Mongo error can
// never leak here even by accident. Nothing renders when `error` is falsy.
export default function MutationErrorAlert({ error, testId }) {
  if (!error) return null;

  return (
    <Alert variant="destructive" className="border-rose-500/30 bg-rose-500/10 text-rose-200" data-testid={testId}>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="text-rose-200">{error.message}</AlertDescription>
    </Alert>
  );
}
